

































































































































import Vue from 'vue';

export default Vue.extend({
  name: 'HubButton' as string,

  inheritAttrs: false,

  props: {
    color: {
      type: String,
      default: 'primary', // $hubColors.accent
    },
    free: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    shadow: {
      type: Boolean,
      default: false,
    },
    square: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
    platform: {
      type: String,
      default: '',
    },
  },

  computed: {
    width(): number | null {
      if (this.free) return null;
      if (!this.large) {
        if (this.$vuetify.breakpoint.sm) return 141;
        if (this.$vuetify.breakpoint.md) return 135;
        if (this.$vuetify.breakpoint.lg) return 171;
        if (this.$vuetify.breakpoint.xl) return 170;
      } else {
        if (this.$vuetify.breakpoint.sm) return 141;
        if (this.$vuetify.breakpoint.md) return 170;
        if (this.$vuetify.breakpoint.lg) return 179;
        if (this.$vuetify.breakpoint.xl) return 191;
      }
      return null;
    },
    height(): number | null {
      if (this.free) return null;
      if (!this.large) {
        if (this.$vuetify.breakpoint.sm) return 42;
        if (this.$vuetify.breakpoint.md) return 39;
        if (this.$vuetify.breakpoint.lg) return 45;
        if (this.$vuetify.breakpoint.xl) return 51;
      } else {
        if (this.$vuetify.breakpoint.sm) return 42;
        if (this.$vuetify.breakpoint.md) return 53;
        if (this.$vuetify.breakpoint.lg) return 53;
        if (this.$vuetify.breakpoint.xl) return 57;
      }
      return null;
    },
    style(): string {
      if (this.platform === 'windows') {
        return 'background-color: #4195cc; border-color: #4195cc; color: #fff';
      }
      if (this.platform === 'linux') {
        return 'border-color: #FF6534; color: #FF6534;';
      }
      if (this.platform === 'mac') {
        return `background: linear-gradient(270deg, rgba(58,122,245,1) 0%, rgba(135,174,249,1) 51%, rgba(255,255,255,1) 100%);
          border-color: #000;
          color: #fff;`;
      }
      return '';
    },
  },
});
